<script setup>
import { useCustomFieldRenderer } from '@/composables/useCustomFieldRenderer'

const { $getI18n: getI18n } = useNuxtApp()

const props = defineProps({
    project: {
        type: Object,
        required: true
    },
    unit: {
        type: Object,
        required: true
    },
    fieldKey: {
        type: String,
        required: true
    }
})

const customFieldRenderer = useCustomFieldRenderer(props.project, props.unit, props.fieldKey)

const {
    field,
    raw,
    typed,
    full,
    prefix,
    suffix,
    customRenderer,
    hideRenderer,
    hasPrefix,
    hasSuffix,
    hasCustomRenderer,
    hasHideRenderer,
    isHidden
} = customFieldRenderer
</script>
<template>
    <span v-if="project && unit && fieldKey">
        <template v-if="isHidden">
            <slot v-if="hasHideRenderer" name="hide">
                <div style="display: inline" v-html="hideRenderer" />
            </slot>
            <slot
                v-else
                name="hidden"
                :field="field"
                :raw="raw"
                :typed="typed"
                :full="full"
                :getI18n="getI18n"
                :hasPrefix="hasPrefix"
                :prefix="prefix"
                :hasSuffix="hasSuffix"
                :suffix="suffix"
            >
                -
            </slot>
        </template>
        <template v-else>
            <slot name="prefix" :field="field" :hasPrefix="hasPrefix" :prefix="prefix">
                <template v-if="hasPrefix">{{ prefix }}&nbsp;</template>
            </slot>
            <slot v-if="hasCustomRenderer" name="custom" :raw="raw" :typed="typed">
                <div
                    style="display: inline"
                    v-html="
                        customRenderer
                            .replace('{value}', typed)
                            .replace('{typed}', typed)
                            .replace('{raw}', raw)
                    "
                />
            </slot>
            <slot v-else :field="field" :raw="raw" :typed="typed" :full="full" :getI18n="getI18n">
                {{ typed }}
            </slot>
            <slot name="suffix" :field="field" :hasSuffix="hasSuffix" :suffix="suffix">
                <template v-if="hasSuffix">&nbsp;{{ suffix }}</template>
            </slot>
        </template>
    </span>
</template>
<style scoped></style>
